// Illaoi - Tentacle Smash: tentacles slam onto the target.
// Nth cast summons N tentacles each dealing N× base damage.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const illaoiTentacle: Ability = {
  id: "illaoiTentacle",
  displayName: "Tentacle Smash",
  description: "Summons tentacles that slam the target. Each cast adds another tentacle and multiplies damage.",
  iconId: "IllaoiQ",

  targetShape({ caster, target }) {
    // One entry per tentacle — the animator uses shape.length as the tentacle count.
    const hitCount = (caster.abilityCastCount ?? 0) + 1;
    return Array.from({ length: hitCount }, () => target.pos);
  },

  computeHits({ caster, target }) {
    const stats = effectiveStats(caster);
    const hitCount = (caster.abilityCastCount ?? 0) + 1;
    const baseDmg = stats.ad * 0.45 + 8;
    const perHit = physicalDamage(baseDmg * hitCount);
    const hits: AbilityHit[] = [];
    for (let i = 0; i < hitCount; i++) {
      hits.push({ target, amount: perHit, type: "physical", suppressPopup: i > 0, tentacleHit: true });
    }
    return hits;
  },
};
